module.exports = __webpack_public_path__ + "static/media/circle-arrow-button.72f37195.svg";